import {RequestStatus} from "../../utils/Enums";
import {AmountResult, StatusResult} from "../../models/Results";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {apiClient} from "../../utils/ApiClient";

interface ResultsState {
    statuses: StatusResult[];
    userStatuses: StatusResult[];
    amounts: AmountResult[];
    profits: AmountResult[];
    me: any;
    getStatusesStatus: RequestStatus;
    getAmountsStatus: RequestStatus;
    getProfitStatus: RequestStatus;
}

const initialState: ResultsState = {
    statuses: [],
    userStatuses: [],
    amounts: [],
    profits: [],
    me: null,
    getStatusesStatus: RequestStatus.Idle,
    getAmountsStatus: RequestStatus.Idle,
    getProfitStatus: RequestStatus.Idle
}

export const getStatuses = createAsyncThunk(
    'results/getStatuses',
    async (_, {rejectWithValue}) => {
        const response = await apiClient.get('results/statuses');
        return response.data;
    }
);

export const getUserStatuses = createAsyncThunk(
    'results/getUserStatuses',
    async (id:string, {rejectWithValue}) => {
        const response = await apiClient.get(`results/statuses/${id}`);
        return response.data;
    }
);

export const getAmounts = createAsyncThunk(
    'results/getAmounts',
    async (_, {rejectWithValue}) => {
        const response = await apiClient.get('results/amount');
        return response.data;
    }
);

export const getProfits = createAsyncThunk(
    'results/getProfits',
    async (_, {rejectWithValue}) => {
        const response = await apiClient.get('results/profit');
        return response.data;
    }
);

export const getMyResults = createAsyncThunk('clients/getMyResults', async (_, {rejectWithValue}) => {

    const searchParams = new URLSearchParams(window.location.search);
    const fromDate = searchParams.get('fromDate');
    const toDate = searchParams.get('toDate');
    const user = searchParams.get('user');

    const url = `results/me?fromDate=${fromDate}&toDate=${toDate}&user=${user}&perPage=${user}`;

    const response = await apiClient.get(url);
    return response.data;

});

const resultsSlice = createSlice({
    name: 'results',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getStatuses.pending, (state) => {
                state.getStatusesStatus = RequestStatus.Loading;
            })
            .addCase(getStatuses.fulfilled, (state, action) => {
                state.getStatusesStatus = RequestStatus.Success;
                state.statuses = action.payload;
            })
            .addCase(getStatuses.rejected, (state, action) => {
                state.getStatusesStatus = RequestStatus.Failed;
            })

            .addCase(getUserStatuses.pending, (state) => {
                state.getStatusesStatus = RequestStatus.Loading;
            })
            .addCase(getUserStatuses.fulfilled, (state, action) => {
                state.getStatusesStatus = RequestStatus.Success;
                state.userStatuses = action.payload;
            })
            .addCase(getUserStatuses.rejected, (state, action) => {
                state.getStatusesStatus = RequestStatus.Failed;
            })

            .addCase(getAmounts.pending, (state) => {
                state.getAmountsStatus = RequestStatus.Loading;
            })
            .addCase(getAmounts.fulfilled, (state, action) => {
                state.getAmountsStatus = RequestStatus.Success;
                state.amounts = action.payload;
            })
            .addCase(getAmounts.rejected, (state, action) => {
                state.getAmountsStatus = RequestStatus.Failed;
            })

            .addCase(getProfits.pending, (state) => {
                state.getProfitStatus = RequestStatus.Loading;
            })
            .addCase(getProfits.fulfilled, (state, action) => {
                state.getProfitStatus = RequestStatus.Success;
                state.profits = action.payload;
            })
            .addCase(getProfits.rejected, (state, action) => {
                state.getProfitStatus = RequestStatus.Failed;
            })

            .addCase(getMyResults.pending, (state) => {
                state.getProfitStatus = RequestStatus.Loading;
            })
            .addCase(getMyResults.fulfilled, (state, action) => {
                state.getProfitStatus = RequestStatus.Success;
                state.me = action.payload;
            })
            .addCase(getMyResults.rejected, (state, action) => {
                state.getProfitStatus = RequestStatus.Failed;
            });
    },
});

export default resultsSlice.reducer;